export function extractTransformationAndPublicIdSegment(_url) {
	if (!_url) return null;

	try {
		const cleanUrl = _url.replace(/^\/\//, "https://");
		const { pathname, host } = new URL(cleanUrl);

		const qIndex = pathname.indexOf("q_auto");
		if (qIndex === -1) return null;

		const transformations = pathname.slice(1, qIndex);

		const publicIdStart = pathname.indexOf("/", qIndex + 6);
		const publicId = publicIdStart !== -1 ? pathname.slice(publicIdStart + 1) : "";
		const baseUrl = pathname.startsWith("/sunwing-test/") ? `${host}/sunwing-test` : host;

		return {
			transformations,
			publicId,
			baseUrl,
		};
	} catch (error) {
		console.error(`Error: ${error}`);
	}
}
